import React, { ChangeEvent, KeyboardEvent, useRef, useState } from 'react';
import { AuthLayout, ButtonBlockPrimary } from '../../components';
import { useNavigate, useParams } from 'react-router-dom';
import { Totp } from '../../type/otp';
import { verifyOtp } from '../../service/authService';
import { showMessage } from '../../utls/message';

const OtpResetPassword = () => {
    const navigate = useNavigate();
    const { clientId } = useParams();

    const [code1, setCode1] = useState("")
    const [code2, setCode2] = useState("")
    const [code3, setCode3] = useState("")
    const [code4, setCode4] = useState("")
    const [code5, setCode5] = useState("")

    const code1Ref = useRef<HTMLInputElement>(null);
    const code2Ref = useRef<HTMLInputElement>(null);
    const code3Ref = useRef<HTMLInputElement>(null);
    const code4Ref = useRef<HTMLInputElement>(null);
    const code5Ref = useRef<HTMLInputElement>(null);

    const focusNextInput = (currentRef: React.RefObject<HTMLInputElement | null>) => {

        if (currentRef.current?.value != null && currentRef.current?.value !== "") {
            if (currentRef === code1Ref && code2Ref.current) code2Ref.current.focus();
            else if (currentRef === code2Ref && code3Ref.current) code3Ref.current.focus();
            else if (currentRef === code3Ref && code4Ref.current) code4Ref.current.focus();
            else if (currentRef === code4Ref && code5Ref.current) code5Ref.current.focus();
        }
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>, currentRef: React.RefObject<HTMLInputElement | null>) => {
        const value = e.target.value;

        switch (currentRef) {
            case code1Ref:
                setCode1(value);
                break;
            case code2Ref:
                setCode2(value);
                break;
            case code3Ref:
                setCode3(value);
                break;
            case code4Ref:
                setCode4(value);
                break;
            case code5Ref:
                setCode5(value);
                break;
            default:
                break;
        }
        if (currentRef) {
            focusNextInput(currentRef);
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, currentRef: React.RefObject<HTMLInputElement | null>) => {
        if (e.key === 'Backspace' && e.currentTarget.value === '') {
            if (currentRef === code2Ref) {
                e.preventDefault();
                code1Ref.current?.focus()
            } else if (currentRef === code3Ref) {
                e.preventDefault();
                code2Ref.current?.focus()
            } else if (currentRef === code4Ref) {
                e.preventDefault();
                code3Ref.current?.focus();
            } else if (currentRef === code5Ref) {
                e.preventDefault();
                code4Ref.current?.focus();
            }
        }
    };

    const onSubmit = async () => {
        const data: Totp = {
            otpCode: code1 + code2 + code3 + code4 + code5,
            uniqueId: clientId!,
            slug: '',
            otpStatus: '',
            otpExp: ''
        }

        const response = await verifyOtp(data);
        console.log(response)
        if (!response.error) {
            navigate(`/activation/reset-password/new-password/${data.uniqueId}`, { state: { otp: response.data } })
        } else {
            showMessage(response.message, "error");
        }
    }

    return (
        <AuthLayout title='Verifikasi'>
            <div className="w-full flex justify-center mt-20">
                <img src="/assets/imgs/icon-otp.png" alt="" />
            </div>
            <div className="w-full justify-center text-center m5-5">
                <h2 className="text-[20px] font-bold">Periksa Email Anda</h2>
                <h4 className="text-[12px]">Kami baru saja mengirimkan OTP ke alamat email <br />Anda yang terdaftar</h4>
            </div>
            <div className='flex gap-5 p-10 justify-between'>
                <input type='text'
                    ref={code1Ref}
                    value={code1 || ''}
                    onChange={(e) => handleChange(e, code1Ref)}
                    maxLength={1}
                    className="flex text-center input-otp no-spinners autofocus" />
                <input type='text'
                    ref={code2Ref}
                    value={code2 || ''}
                    onChange={(e) => handleChange(e, code2Ref)}
                    onKeyDown={(e) => handleKeyDown(e, code2Ref)}
                    maxLength={1}
                    className="flex text-center input-otp no-spinners autofocus" />
                <input type='text'
                    ref={code3Ref}
                    value={code3 || ''}
                    onChange={(e) => handleChange(e, code3Ref)}
                    onKeyDown={(e) => handleKeyDown(e, code3Ref)}
                    maxLength={1}
                    className="flex text-center input-otp no-spinners autofocus" />
                <input type='text'
                    ref={code4Ref}
                    value={code4 || ''}
                    onChange={(e) => handleChange(e, code4Ref)}
                    onKeyDown={(e) => handleKeyDown(e, code4Ref)}
                    maxLength={1}
                    className="flex text-center input-otp no-spinners autofocus" />
                <input type='text'
                    ref={code5Ref}
                    value={code5 || ''}
                    onChange={(e) => handleChange(e, code5Ref)}
                    onKeyDown={(e) => handleKeyDown(e, code5Ref)}
                    maxLength={1}
                    className="flex text-center input-otp no-spinners autofocus" />
            </div>
            <div className="my-3">
                <ButtonBlockPrimary
                    label='Verifikasi OTP'
                    onClick={() => { onSubmit() }} />
                <h4 className="flex justify-center text-center mt-5 gap-2 text-[14px]"><span className="text-dark fontbold">Jika
                    anda tidak
                    tidak menerima OTP, </span> <span className="text-danger font-bold"> <button>Kirim Ulang</button>
                    </span>
                </h4>
            </div>
        </AuthLayout>
    );
};

export default OtpResetPassword;